"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MAX_COMMENT_LENGTH = void 0;
exports.MAX_COMMENT_LENGTH = 5000;
